import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../../components/Common/TextInput';
import CallOut from '../../../components/Common/CallOut';
import Notification from '../../../components/Common/Notification';
import ActivityLoader from '../../../components/Common/ActivityLoader';
import { useTheme } from '../../../DataStore/ThemeContext';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    roleName: '',
    loading: false,
}

const UpdateRole = ({role}) => {

    const {setNotify} = useTheme();

    const [info, setInfo] = useState(null);
    const {getUserRoles} = useConfig();

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(()=>{
        dispatch({type: 'roleName', value: role.role_name})
    }, [])

    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    const handleSave = async (event) =>{
        event.preventDefault();
        if(state.loading){
            return;
        }
        dispatch({type: 'loading', value: true});
        const server_response = await ajaxConfig.updateUserRole({'role_id': role.role_id, 'role_name': state.roleName});
        dispatch({type: 'loading', value: false});
        if(server_response.status==="OK"){
            setNotify(<Notification type='success' message={server_response.message}/>);
            setInfo(<Notification type='success' message={server_response.message}/>);
            /**
             * Refresh data in context after the success notification has showed up to mitigate the re-render effect.
             */
            getUserRoles(true);
           
        }else{
            setInfo(<Notification type='danger' message={server_response.message}/>);

        }

    }

    return (
        <div className="card-body">

            <CallOut 
                title="User Roles"
                description="Roles restrict access to sensitive data and system features based on the user's job function."
             />
            {info}
            <form className="form-horizontal" method="post" onSubmit={handleSave}>

                        <TextInput
                            type="text"
                            label="Role Name"
                            placeholder="Enter Role Name"
                            leftIcon="fa fa-user-tag"
                            value={state.roleName}
                            onChange={e => dispatch({type: 'roleName', value: e.target.value})}
                            required
                            wrap
                            />
                

                        

                            <div className="text-right">
                               {!state.loading && <button type="submit" className="btn btn-lg btn-success">Save Changes</button>}
                               {state.loading && <ActivityLoader />}
                            </div>

                        </form> 


        </div>
    );
};

export default UpdateRole;